import './styles.scss';
import React from 'react';
import PropTypes from 'prop-types';
import { Form } from '@edx/paragon';
import { FormattedMessage } from 'gatsby-plugin-react-intl';

function EmailOptIn({
  partners,
  optIn,
  title,
  toggleEmailOptIn,
}) {
  const getPartnerList = () => {
    const list = partners.map(({ key }) => key);

    return list.join(', ');
  };

  return (
    <div className="form-field mb-3 pb-1 mb-sm-4 pb-sm-0 d-flex align-items-start">
      <Form.Checkbox id="email-opt-in" className="email-opt-in" value={optIn} checked={optIn} onChange={toggleEmailOptIn}>
        <FormattedMessage
          id="prospectus.emailOptIn.label"
          defaultMessage="I would like to receive email from {partnerList} and learn about other offerings related to {title}."
          description="A checkbox which allows the user to consent to receive emails from the partner(s) running the course."
          values={{
            partnerList: getPartnerList(),
            title,
          }}
        >{text => <div id="email-terms-test-id" className="x-small text-gray-500">{text}</div>}
        </FormattedMessage>
      </Form.Checkbox>
    </div>
  );
}

EmailOptIn.propTypes = {
  optIn: PropTypes.bool.isRequired,
  partners: PropTypes.arrayOf(PropTypes.shape({
    uuid: PropTypes.string,
    key: PropTypes.string,
    logoImageUrl: PropTypes.string,
    name: PropTypes.string,
  })).isRequired,
  title: PropTypes.string.isRequired,
  toggleEmailOptIn: PropTypes.func.isRequired,
};

export default EmailOptIn;
